import { createRoute } from '@tanstack/react-router'

import { ErrorBoundary } from '@shared/components/ErrorHandling'
import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { JSON } from 'domains/Showcases/Collections/Showcases/Showcase'
import { Dashboard } from 'domains/Showcases/Collections/Showcases/Showcase/Config'
import { collectionRoute } from 'pages/NWPlatform/Collections/Collection/Routing'
import { Structure } from 'pages/NWPlatform/Collections/Collection/Showcase/Structure'

export const showcaseRoute = createRoute({
  getParentRoute: () => collectionRoute,
  path: `${StaticRouteParameter.SHOWCASES}/${DynamicRouteParameterWPrefix.SHOWCASE_ID}`,
  loader: () => ({
    crumb: { title: null },
  }),
})

export const showcaseLayoutRoute = createRoute({
  getParentRoute: () => showcaseRoute,
  id: 'showcaseLayout',
  component: Structure,
  errorComponent: ErrorBoundary,
})

export const configRoute = createRoute({
  getParentRoute: () => showcaseLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: Dashboard,
})

export const rawRoute = createRoute({
  getParentRoute: () => showcaseLayoutRoute,
  path: StaticRouteParameter.RAW,
  component: JSON,
})
